export const educationData = [
  {
    id: 1,
    institution: "B. P. Poddar Institute of Management and Technology, Kolkata",
    course: "Bachelor of Technology (ECE)",
    startYear: "2018",
    endYear: "2022",
  },
  {
    id: 2,
    institution: "D.N. Y College, Madhubani",
    course: "Higher Secondary Education",
    startYear: "2017",
    endYear: "2018",
  },
  //   ,
  //   {
  //     id: 3,
  //     institution: "Hawking University, Cambridge",
  //     course: "Master of Technology",
  //     startYear: "2019",
  //     endYear: "Present",
  //   },
];
